import React from "react";
import { ReactComponent as EmptyStateIcon } from "../../../assets/icons/empty-state.svg";
import { Box, Typography } from "@mui/material";
import { commonStyles } from "../../../assets/MUIStyles/commonStyles";

const EmptyState = ({ message = "No Data Found" }) => {
  return (
    <Box sx={commonStyles.emptyState.container}>
      <Typography sx={commonStyles.emptyState.innerContainer}>
        {message} ...
      </Typography>
      <Box>
        <EmptyStateIcon />
      </Box>
    </Box>
  );
};

export default EmptyState;
